import React, { Component } from 'react';
import { Textfield, Checkmark, FormSection, Radiobutton, Chip } from './form';

export default class DocumentForm extends Component {

	constructor(props) {
		super();
		const af = props.autoFill;
		this.state = {
			serviceName: af.service ? af.service.name || '' : '',
			serviceURL: af.service ? af.service.url || '' : '',
			companyName: af.company ? af.company.name || '' : '',
			companyPhone: af.company ? af.company.phone || '' : '',
			companyEmail: af.company ? af.company.email || '' : '',
			companyAddress: af.company ? af.company.address || '' : '',
			companyContact: af.company ? af.company.contact || [] : [],
			dpoName: af.dpo ? af.dpo.name || '' : '',
			dpoPhone: af.dpo ? af.dpo.phone || '' : '',
			dpoEmail: af.dpo ? af.dpo.email || '' : '',
			dpoAddress: af.dpo ? af.dpo.address || '' : '',
			dpoContact: af.dpo ? af.dpo.contact || [] : [],
			data: af.personalData ? af.personalData.data || ["etunimi", "sukunimi", "puhelinnumero", "sähköpostiosoite"] : ["etunimi", "sukunimi", "puhelinnumero", "sähköpostiosoite"],
			purposes: af.personalData ? af.personalData.purposes || [] : [],
			sources: af.personalData ? af.personalData.sources || [] : [],
			otherSource: af.personalData ? af.personalData.sourceExplanation || '' : '',
			discloseCompulsory: af.personalData ? af.personalData.disclose ? af.personalData.disclose.compulsory || true : true : true,
			discloseLegal: af.personalData ? af.personalData.disclose ? af.personalData.disclose.legal || false : false : false,
			discloseSanctions: af.personalData ? af.personalData.disclose ? af.personalData.disclose.sanctions || '' : '' : '',
			recipients: af.personalData ? af.personalData.recipients || [{}] : [{}],
			/*dataRecipientIsCompany: af.personalData ? af.personalData.recipient ? af.personalData.recipient.IsCompany || false : false : false,
			dataRecipientName: af.personalData ? af.personalData.recipient ? af.personalData.recipient.name || '' : '': '',
			dataRecipientPhone: af.personalData ? af.personalData.recipient ? af.personalData.recipient.phone || '' : '' : '',
			dataRecipientEmail: af.personalData ? af.personalData.recipient ? af.personalData.recipient.email || '' : '' : '',
			dataRecipientAddress: af.personalData ? af.personalData.recipient ? af.personalData.recipient.address || '' : '' : '',*/
			dataExpireType: af.personalData ? af.personalData.expire ? af.personalData.expire.type || '' : '' : '',
			dataExpireDate: af.personalData ? af.personalData.expire ? af.personalData.expire.date || '' : '' : '',
			dataExpireYears: af.personalData ? af.personalData.expire ? af.personalData.expire.years || 0 : 0 : 0,
			dataExpireMonths: af.personalData ? af.personalData.expire ? af.personalData.expire.months || 0 : 0 : 0,
			dataExpireDays: af.personalData ? af.personalData.expire ? af.personalData.expire.days || 0 : 0 : 0,
			dataTransfer: af.personalData ? af.personalData.transfer ? true : false : false,
			dataProtection: af.personalData ? af.personalData.protection || '' : '',
			dataCopy: af.personalData ? af.personalData.copy || '' : '',
			dataAutomation: af.personalData ? af.personalData.automation ? af.personalData.automation.degree || [] : [] : [],
			dataAutomationExplanation: af.personalData ? af.personalData.automation ? af.personalData.automation.explanation || '' : '' : '',
			addData: '',
			addPurpose: '',
			extraPurposes: [],
			isDpo: !!af.dpo,
			validFields: {}
    	};
    	this.handleChange = this.handleChange.bind(this);
    	this.handleArrayChange = this.handleArrayChange.bind(this);
    	this.handleBooleanChange = this.handleBooleanChange.bind(this);
    	this.deleteData = this.deleteData.bind(this);
    	this.insertData = this.insertData.bind(this);
    	this.addPurpose = this.addPurpose.bind(this);
    	this.makeDocument = this.makeDocument.bind(this);
    	this.handleRecipientChange = this.handleRecipientChange.bind(this);
    	this.addRecipient = this.addRecipient.bind(this);
    	this.removeRecipient = this.removeRecipient.bind(this);
    	this.validateField = this.validateField.bind(this);
    	this.clearDataAutomation = this.clearDataAutomation.bind(this);
	}

	makeDocument(e) {
		e.preventDefault(); // <- prevent form submit from reloading the page
		const s = this.state;
		var doc = {
			service: {
				name: s.serviceName,
				url: s.serviceURL
			},
			company: {
				name: s.companyName,
				phone: s.companyPhone,
				email: s.companyEmail,
				address: s.companyAddress,
				contact: s.companyContact
			},
			personalData: {
				data: s.data,
				purposes: s.purposes,
				sources: s.sources,
				sourceExplanation: s.otherSource,
				recipients: s.recipients,
				expire: false,
				transfer: s.dataTransfer,
				disclose: {
					compulsory: s.discloseCompulsory,
					legal: s.discloseLegal,
					sanctions: s.discloseSanctions
				},
				automation: {
					degree: s.dataAutomation,
					explanation: s.dataAutomationExplanation
				}
			},
		}
		if (s.isDpo) {
			doc.dpo = {
				name: s.dpoName,
				phone: s.dpoPhone,
				email: s.dpoEmail,
				contact: s.dpoContact
			}
		}
		if (s.dataTransfer) {
			doc.personalData.protection = s.dataProtection;
			doc.personalData.copy = s.dataCopy;
		}
		if (s.dataExpireType === "until") {
			doc.personalData.expire = {
				type: "until",
				date: s.dataExpireDate
			}
		}
		else if (s.dataExpireType === "interval") {
			doc.personalData.expire = {
				type: "interval",
			}
			switch (s.dataExpireDMY) {
				case "dataExpireYears": doc.personalData.expire.years = s.dataExpireYears;
				break;
				case "dataExpireMonths": doc.personalData.expire.months = s.dataExpireMonths;
				break;
				case "dataExpireDays": doc.personalData.expire.days = s.dataExpireDays;
				break;
				default: break;
			}
		}
		this.props.onSave(doc, e);
	}

	handleChange(e) {
		this.validateField(e.target.name, e.target.value);
    	this.setState({[e.target.name]: e.target.value});
  	}

  	validateField(name, value) {
  		let validFields = this.state.validFields;
  		const phone = /^([(]?[+]?[0-9]{0,3}[)]?[\s-]?[0-9]+[\s-]?[0-9]+[\s-]?[0-9]+[\s-]?[0-9]+)$/; // Älä kysy miksi, mutta tämä toimii.
  		const email = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; // Äläkä tästäkään
  		if (name === "companyPhone" ||
  			name === "dpoPhone" ||
  			name === "phone") {
  				validFields[name] = phone.test(value);
  		}
  		else if (name === "companyEmail" ||
  			name === "dpoEmail" ||
  			name === "email") {
  				validFields[name] = email.test(value);
  		}
  		else validFields[name] = true;
  		this.setState({validFields});
  	}

  	handleArrayChange(e, arrayName) {
  		let arr = this.state[arrayName];
  		if(e.target.checked) {
  			if(!arr.includes(e.target.name)) {
  				arr.push(e.target.name);
  			}
  		}
  		else {
  			if(arr.includes(e.target.name)) {
  				arr.splice(arr.indexOf(e.target.name), 1);
  			}
  		}
  		this.setState({[arrayName]: arr});
  	}

  	handleBooleanChange(e) {
  		this.setState({[e.target.name]: !this.state[e.target.name]});
  	}

  	handleRecipientChange(e, recipient) {
  		let r = recipient; // copy recipient, modify r
  		if (e.target.name === "isCompany") {
  			r.isCompany = !r.isCompany
  		}
  		else {
  			r[e.target.name] = e.target.value;
  		}
  		let recipients = this.state.recipients;
  		recipients[recipients.indexOf(recipient)] = r; // set r to the place of original recipient
  		this.setState({recipients});
  	}

  	clearDataAutomation(e) {
  		if(e.target.checked) {
  			this.setState({dataAutomation: []});
  		}
  	}

  	addRecipient() {
  		let recipients = this.state.recipients;
  		recipients.push({});
  		this.setState({recipients});
  	}

  	removeRecipient(r) {
  		let recipients = this.state.recipients;
  		if (recipients.includes(r)) {
  			recipients.splice(recipients.indexOf(r), 1);
  		}
  		this.setState({recipients});
  	}

  	deleteData(d) {
  		let data = this.state.data;
  		if (data.includes(d)) {
  			data.splice(data.indexOf(d), 1);
  		}
  		this.setState({data});
  	}

  	insertData() {
  		let data = this.state.data;
  		let newData = this.state.addData;
  		newData = newData.toLowerCase();
  		if (!newData || data.includes(newData)) {
  			return;
  		}
  		data.push(newData);
  		this.setState({data});
  		this.setState({addData: ''});
  	}

  	addPurpose() {
  		let purposes = this.state.purposes;
  		let newPurpose = this.state.addPurpose;
  		let extraPurposes = this.state.extraPurposes;
  		newPurpose = newPurpose.toLowerCase();
  		if (!newPurpose || purposes.includes(newPurpose)) {
  			return;
  		}
  		purposes.push(newPurpose);
  		extraPurposes.push(newPurpose);
  		this.setState({purposes});
  		this.setState({addPurpose: ''});
  	}

  	onCancel(e) {
  		if (window.confirm("Oletko varma, että haluat hylätä muutokset? \n\n Tätä toimintoa ei voi kumota.")) {
  			window.history.back();
      	}
  	}

	render() {
		return(
			<div>
				<div>
					<h2>Perustiedot</h2>
					<h4>Yrityksen tiedot</h4>
					<div className="mdl-grid">
						<div className="mdl-cell">
							<Textfield
								header="Yrityksen nimi"
								name="companyName"
								value={this.state.companyName}
								onChange={this.handleChange}
							/>
						</div>
						<div className="mdl-cell">
							<Textfield
								header="Osoite"
								name="companyAddress"
								value={this.state.companyAddress}
								onChange={this.handleChange}
							/>
						</div>
						<div className="mdl-cell">
							<Textfield
								header="Puhelinnumero"
								name="companyPhone"
								value={this.state.companyPhone}
								onChange={this.handleChange}
							/>
						</div>
						<div className="mdl-cell">
							<Textfield
								header="Sähköpostiosoite"
								name="companyEmail"
								value={this.state.companyEmail}
								onChange={this.handleChange}
							/>
						</div>
					</div>
					<h4>Palvelun tiedot</h4>
					<div className="mdl-grid">
						<div className="mdl-cell">
							<Textfield
								header="Palvelun nimi"
								name="serviceName"
								value={this.state.serviceName}
								onChange={this.handleChange}
							/>
						</div>
						<div className="mdl-cell">
							<Textfield
								header="Palvelun kotisivut"
								placeholder="https://..."
								name="serviceURL"
								value={this.state.serviceURL}
								onChange={this.handleChange}
							/>
						</div>
					</div>
				</div>
				<h2>Henkilötietojen käsittely</h2>
        		<div className="mdl-grid">
        			<div className="mdl-cell">
        				<FormSection
        					header="Kerättävät henkilötiedot"
        					help="Jos henkilötietoja ei ole saatu rekisteröidyltä itseltään vaan jostain muusta tietolähteestä, tulee rekisteröityä informoida käsiteltävistä henkilötietoryhmistä, sillä rekisteröity ei voi tällaista tietää. Listaa tähän kaikki henkilötiedot, joita käsittelette.">
        					{this.state.data.map((d, i) =>
        						<Chip 	key={i}
        								text={d[0].toUpperCase() + d.substring(1)}
        								onDelete={() => this.deleteData(d)}/>
        					)}
							<Textfield
								name="addData"
								value={this.state.addData}
								onChange={this.handleChange}
								onKeyPress={event => {
                					if (event.key === 'Enter') {
                  						this.insertData()
                					}
              					}}
							/>
        					<div>
        						<button onClick={this.insertData} className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab">
  									<i className="material-icons">add</i>
								</button>
							</div>
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Mistä henkilötiedot on saatu?"
							help="Esim. työsuhteessa voi olla sopimukseen perustuva vaatimus antaa tiettyjä tietoja nykyiselle tai tulevelle työnantajalle.">
							<p>Rastita kaikki väittämät, jotka pitävät paikkansa</p>
							<Checkmark 	name="user"
										text="Käyttäjä on itse antanut tietonsa"
										checked={this.state.sources.includes("user")}
										onChange={(event) => this.handleArrayChange(event, "sources")} />
							{this.state.sources.indexOf("user") > -1 ?
							<Checkmark 	name="discloseLegal"
										text="Henkilötietojen antaminen on lakisääteinen tai sopimukseen perustuva vaatimus"
										checked={this.state.discloseLegal}
										onChange={this.handleBooleanChange} />
							: null}
							{this.state.sources.indexOf("user") > -1 ?
							<Checkmark 	name="discloseCompulsory"
										text="Palvelua pystyy käyttämään täysmittaisesti myös ilman henkilötietojen luovutusta"
										checked={!this.state.discloseCompulsory}
										onChange={this.handleBooleanChange} />
							: null}
							<Checkmark 	name="other"
										text="Tietoja kerätään muualta kuin käyttäjältä itseltään"
										checked={this.state.sources.includes("other")}
										onChange={(event) => this.handleArrayChange(event, "sources")} />
							{this.state.discloseCompulsory && this.state.sources.indexOf("user") > -1 ?
							<FormSection
								header="Mitä seuraamuksia on, jos käyttäjä ei luovuta tietojaan? Esimerkiksi rajoitetaanko palvelun käyttöä?"
								help="Esim. verkkolomakkeilla tulisi selkeästi esittää, mitkä tiedot ovat pakollisia, ja mitkä ovat mahdolliset seuraamukset niiden antamatta jättämisestä. Samoin tulisi kertoa tai muuten selkeästi esittää, mitkä tiedot eivät ole pakollisia.">
								<textarea 	className="mdl-textfield__input"
										type="text"
										rows= "3"
										id="sample5"
										placeholder="..."
										name="discloseSanctions"
										value={this.state.discloseSanctions}
										onChange={this.handleChange} />
							</FormSection> : null}
							{this.state.sources.indexOf("other") > -1 ?
							<FormSection
								header="Selitä mahdollisimman yksityiskohtaisesti, miten henkilötietoja on kerätty muutoin kuin käyttäjän antamana."
								help="Tiedot tietolähteiden luonteesta (esim. onko tiedot saatu julkisesta vai yksityisestä tietolähteestä). Nimenomainen tietolähde tulisi mainita, jos se vain on mahdollista.">
								<textarea 	className="mdl-textfield__input"
										type="text"
										rows= "3"
										id="sample5"
										placeholder="..."
										name="otherSource"
										value={this.state.otherSource}
										onChange={this.handleChange} />
							</FormSection> : null}
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Henkilötietojen käyttötarkoitus">
							<Checkmark 	name="suoramarkkinointi"
										text="Suoramarkkinointi"
										checked={this.state.purposes.includes("suoramarkkinointi")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="markkinatutkimus"
										text="Markkinatutkimus"
										checked={this.state.purposes.includes("markkinatutkimus")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="tuotetestit"
										text="Tuotetestit"
										checked={this.state.purposes.includes("tuotetestit")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="palvelun_kehittaminen"
										text="Palvelun kehittäminen"
										checked={this.state.purposes.includes("palvelun_kehittaminen")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="palautteen_kasittely"
										text="Palautteen käsittely"
										checked={this.state.purposes.includes("palautteen_kasittely")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="tietojen_koonti"
										text="Tietojen koonti"
										checked={this.state.purposes.includes("tietojen_koonti")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							<Checkmark 	name="asiakaskokemus"
										text="Asiakaskokemuksen parantaminen"
										checked={this.state.purposes.includes("asiakaskokemus")}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />
							{this.state.extraPurposes.map( (p, i) =>
							<Checkmark 	key={i}
										name={p}
										text={p[0].toUpperCase() + p.substring(1)}
										checked={this.state.purposes.includes(p)}
										onChange={(event) => this.handleArrayChange(event, "purposes")} />)}
							<Textfield
								name="addPurpose"
								value={this.state.addPurpose}
								onChange={this.handleChange}
								onKeyPress={event => {
                					if (event.key === 'Enter') {
                  						this.addPurpose()
                					}
              					}}
							/>
        					<div>
        						<button onClick={this.addPurpose} className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab">
  									<i className="material-icons">add</i>
								</button>
							</div>
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Kuinka pitkään henkilötietoja säilytetään?"
							help="Tietojen säilytysaika tai sen määrittämiskriteerit voidaan johtaa laissa säädetyistä säilytysajoista tai toimialojen käytännesäännöistä. Tärkeää on, että säilyttämisaika on määritelty niin, että sen perusteella rekisteröity voi helposti arvioida, mikä tietojen säilytysaika on. Ei ole riittävää todeta, että henkilötietoja säilytetään toistaiseksi. Eri henkilötietoryhmille ja eri käsittelytarkoituksille tulisi eritellysti määritellä eri säilytysajat.">
							<div className="radio-group">
									<label className="radio-container">
										<input type="radio" name="dataExpireType" value="interval" checked={this.state.dataExpireType === "interval"} onChange={this.handleChange} />
										<span className="radio-checkmark"></span>
									</label>
									<div className="mdl-textfield">
										<input placeholder="" id="sample3" className="mdl-textfield__input" type="text" pattern="-?[0-9]*(\.[0-9]+)?" name={this.state.dataExpireDMY} value={this.state[this.state.dataExpireDMY]} onChange={this.handleChange} />
									</div>
									<div className="mdl-selectfield--floating-label">
										<select name="dataExpireDMY" value={this.state.dataExpireDMY} onChange={this.handleChange} >
											<option value="dataExpireDays">päivää</option>
											<option value="dataExpireMonths">kuukautta</option>
											<option value="dataExpireYears">vuotta</option>
										</select>
									</div>
							</div>
							<div className="radio-group">
								<label className="radio-container">
									<input type="radio" name="dataExpireType" value="until" checked={this.state.dataExpireType === "until"} onChange={this.handleChange} />
									<span className="radio-checkmark"></span>
								</label>
								<div className="mdl-textfield">
									<input placeholder="1.1.2020" id="sample3" className="mdl-textfield__input" type="text" name="dataExpireDate" value={this.state.dataExpireDate} onChange={this.handleChange} />
								</div>
								asti
							</div>
							<div className="radio-group">
								<label className="radio-container">
									<input type="radio" name="dataExpireType" value="" checked={!this.state.dataExpireType} onChange={this.handleChange} />
									<span className="radio-checkmark"></span>
								</label>
								<span>Rekisteröidyn tilin voimassaolon ajan</span>
							</div>
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Henkilötietojen käsittelijät"
							help="Tiedot tulisi antaa kaikista henkilötietojen vastaanottajista ja käsittelijöistä yksilöidysti.">
							{this.state.recipients.map((r, i) =>
							<div key={i}>
								<div className="radio-group">
									<div className="special-checkmark-container">
										<Checkmark 	name="isCompany"
													text="Henkilötietojen käsittelijänä toimii ulkopuolinen yritys"
													checked={r.isCompany}
													onChange={(event) => this.handleRecipientChange(event, r)} />
									</div>
									{ (i>0) ?

										<div className="">
											<button onClick={() => this.removeRecipient(r)} className="mdl-button mdl-js-button mdl-button--icon mdl-button--colored">
			  									<i className="material-icons">clear</i>
											</button>
										</div>
										:
										<div></div>
									}
								</div>


								{r.isCompany ? null : <h6>{this.state.companyName}:ssä henkilötietojen käsittelyyn osallistuu</h6>}
								<Textfield
									placeholder={r.isCompany ? "Yrityksen nimi..." : "Nimi..."}
									name="name"
									value={r.name}
									onChange={(event) => this.handleRecipientChange(event, r)}
								/>
								<Textfield
									placeholder={r.isCompany ? "Yrityksen puhelinnumero..." : "Puhelinnumero..."}
									name="phone"
									value={r.phone}
									onChange={(event) => this.handleRecipientChange(event, r)}
								/>
								<Textfield
									placeholder={r.isCompany ? "Yrityksen sähköpostiosoite..." : "Sähköpostiosoite..."}
									name="email"
									value={r.email}
									onChange={(event) => this.handleRecipientChange(event, r)}
								/>
								{r.isCompany ?
								<Textfield
									placeholder="Yrityksen katuosoite..."
									name="address"
									value={r.address}
									onChange={(event) => this.handleRecipientChange(event, r)}
								/> : null}
							</div>
							)}
							<button onClick={this.addRecipient} className="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab">
  								<i className="material-icons">add</i>
							</button>
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Henkilötietojen automaattinen käsittely"
							help="Onko käsittely automaattista? Tapahtuuko profilointia? Käsittelyn logiikka sekä käsittelyn merkittävyys ja vaikutukset rekisteröidylle.">
							<p>Rastita kaikki väittämät, jotka pitävät paikkansa</p>
							<Checkmark 	name="dataProfiling"
										text="Henkilötietojen perusteella tehdään automaattista profilointia"
										checked={this.state.dataAutomation.includes("dataProfiling") || this.state.dataAutomation.includes("automatedDecisions")}
										onChange={(event) => this.handleArrayChange(event, "dataAutomation")} />
							<Checkmark 	name="automatedDecisions"
										text="Palvelu tekee valintoja automaattisesti profiloinnin perusteella"
										checked={this.state.dataAutomation.includes("automatedDecisions")}
										onChange={(event) => this.handleArrayChange(event, "dataAutomation")} />
							<Checkmark 	name="clearDataAutomation"
										text="Henkilötietojen käsittelyä ei ole automatisoitu"
										checked={!(this.state.dataAutomation.includes("dataProfiling") || this.state.dataAutomation.includes("automatedDecisions"))}
										onChange={this.clearDataAutomation} />
							{this.state.dataAutomation.length ? 
							<FormSection header="Käsittelyn logiikka sekä käsittelyn merkittävyys ja vaikutukset palvelun käyttäjälle">
								<textarea 	className="mdl-textfield__input"
											type="text"
											rows= "3"
											id="sample5"
											placeholder="..."
											name="dataAutomationExplanation"
											value={this.state.dataAutomationExplanation}
											onChange={this.handleChange} />
							</FormSection> : null}
						</FormSection>
					</div>
					<div className="mdl-cell">
						<FormSection
							header="Luovutetaanko henkilötietoja EU:n ulkopuolelle?">
							<Radiobutton	name="dataTransfer"
											text="Kyllä"
											value={true}
											checked={!!this.state.dataTransfer}
											onChange={this.handleBooleanChange}/>
							<Radiobutton	name="dataTransfer"
											text="Ei"
											value={false}
											checked={!this.state.dataTransfer}
											onChange={this.handleBooleanChange}/>
							{this.state.dataTransfer ?
							<div>
								<h5>Tiedot käytettävistä suojatoimista</h5>
  								<div className="mdl-textfield mdl-js-textfield">
    								<textarea className="mdl-textfield__input" type="text" rows= "3" id="sample5" placeholder="Rekisteröidyn käyttäjän tiedot suojataan..." name="dataProtection" value={this.state.dataProtection} onChange={this.handleChange} />
  								</div>
								<h5>Miten käyttäjä saa kopion tiedoistaan tai tiedon niiden sisällöstä?</h5>
								<div className="mdl-textfield mdl-js-textfield">
    								<textarea className="mdl-textfield__input" type="text" rows= "3" id="sample5" placeholder="Rekisteröity käyttäjä voi saada kopion tiedoistaan/koosteen tietojensa sisällöstä..." name="dataCopy" value={this.state.dataCopy} onChange={this.handleChange} />
  								</div>
							</div> : null}
						</FormSection>
					</div>
				</div>
				<h2>Yhteydenotto rekisterinpitäjään ja tietosuojavastaavaan</h2>
				<p>{`Miten käyttäjä voi ottaa yhteyttä rekisterinpitäjään (${this.state.companyName}) tai nimitettyyn tietosuojavastaavaan, jos käyttäjä esimerkiksi haluaa kopion tiedoistaan, haluaa oikaista tai poistaa tietojaan, rajoittaa tietojensa käsittelyä, siirtää tietonsa toiselle rekisterinpitäjälle tai peruuttaa suostumuksensa tietojensa käsittelyyn.`}</p>
				<div className="mdl-grid">
					<div className="mdl-cell">
						<FormSection header={`Yhteydenottotavat rekisterinpitäjään (${this.state.companyName})`}>
							<Checkmark 	name="phone"
										text={`Soittamalla numeroon ${this.state.companyPhone}`}
										checked={this.state.companyContact.includes("phone")}
										onChange={(event) => this.handleArrayChange(event, "companyContact")} />
							<Checkmark 	name="email"
										text={`Sähköpostilla (${this.state.companyEmail})`}
										checked={this.state.companyContact.includes("email")}
										onChange={(event) => this.handleArrayChange(event, "companyContact")} />
							<Checkmark 	name="mail"
										text={`Kirjeellä osoitteeseen ${this.state.companyAddress}`}
										checked={this.state.companyContact.includes("mail")}
										onChange={(event) => this.handleArrayChange(event, "companyContact")} />
						</FormSection>
						{this.state.isDpo ?
						<FormSection header={`Yhteydenottotavat tietosuojavastaavaan (${this.state.dpoName})`}>
							<Checkmark 	name="phone"
										text={`Soittamalla numeroon ${this.state.dpoPhone}`}
										checked={this.state.dpoContact.includes("phone")}
										onChange={(event) => this.handleArrayChange(event, "dpoContact")} />
							<Checkmark 	name="email"
										text={`Sähköpostilla (${this.state.dpoEmail})`}
										checked={this.state.dpoContact.includes("email")}
										onChange={(event) => this.handleArrayChange(event, "dpoContact")} />
						</FormSection> : null}
					</div>
					<div className="mdl-cell">
						<FormSection
							header={`Onko ${this.state.companyName}:lle nimitetty tietosuojavastaava?`}
							help="Tietosuojavastaava täytyy nimittää, jos käsittelijä on viranomainen, käsittely on laajamittaista, tai jos käsittely kohdistyy 9. artiklan mukaisiin erityisiin henkilötietoryhmiin ja 10. artiklassa tarkoitettuihin rikostuomiota tai rikkomuksia koskeviin tietoihin. Laajamittaista käsittelyä on esim. potilastietojen käsittely sairaalan tavanomaisessa toiminnassa, kaupungin joukkoliikennejärjestelmää käyttävien henkilöiden matkatietojen käsittely.">
							<Radiobutton	name="isDpo"
											text="Kyllä"
											value={true}
											checked={!!this.state.isDpo}
											onChange={this.handleBooleanChange}/>
							<Radiobutton	name="isDpo"
											text="Ei"
											value={false}
											checked={!this.state.isDpo}
											onChange={this.handleBooleanChange}/>
						</FormSection>
						{this.state.isDpo ?
						<FormSection header="Tietosuojavastaavan yhteystiedot">
							<Textfield
								placeholder="Nimi..."
								name="dpoName"
								value={this.state.dpoName}
								onChange={this.handleChange}
							/>
							<Textfield
								placeholder="Puhelinnumero..."
								name="dpoPhone"
								value={this.state.dpoPhone}
								onChange={this.handleChange}
							/>
							<Textfield
								placeholder="Sähköpostiosoite..."
								name="dpoEmail"
								value={this.state.dpoEmail}
								onChange={this.handleChange}
							/>
						</FormSection> : null}
					</div>
				</div>
          		{this.props.onSave ? <div className="mdl-button mdl-button--raised mdl-button--accent" onClick={(e) => this.makeDocument(e)}>Save</div> : null}
        		{this.props.onDelete ? <div className="mdl-button mdl-button--raised mdl-button--accent" onClick={(e) => this.props.onDelete(e)}>Delete</div> : null}
      		</div>
		);
	}


}



// WEBPACK FOOTER //
// ./src/components/documentForm.js